module.exports = __webpack_public_path__ + "img/hr-H-T-4-unload-connect-shadow.78e3c4d1.png";